<template>
  <div class="footer__secondary-link-wrapper">
    <sc-link :field="this.fields.Link" class="footer__secondary-link" :editable="false"/>
  </div>
</template>

<script>
//import SitecoreLink from '../../Sitecore/SitecoreLink';
import { Link } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'FooterBottomLink',
  components: {
    ScLink: Link,
  },
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LinkIcon: null,
        Link: null,
      }),
    },
  },
};
</script>
<style lang="scss" scoped></style>
